

define(['squid', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-address-components/src/address-display/directive', 'components/xo-page-components/src/aside-header/directive', 'components/xo-tray-height/dist/directive', 'components/xo-ui-components/src/accessibility/directive'], function (squid, template) {

    squid.module('xo-select-shipping.directive', ['squid', 'xomodel.checkout', 'xo-address-display.directive', 'xo-aside-header.directive', 'xo-tray-height.directive', 'xo-accessibility.directive']).directive('xoSelectShipping', function () {
        return {
            template: template,
            scope: {
                token: '=',
                doneFn: '='
            },
            controller: function controller($scope, $log, $populate, $state, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutShippingAddressesModel, $config, $feature, $renderContent, $locale) {

                $populate($scope, {
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutShippingAddresses: $CheckoutShippingAddressesModel.create($scope.token)
                }).then(function () {
                    $scope.checkoutSession.message = null;
                    $scope.deleteShipping = $scope.checkoutShippingAddresses.addresses.some(function (address) {
                        return !(address.primary_address || address.default_address);
                    });
                });

                $scope.onSelect = function (address) {
                    if (!address.disable_for_transaction) {
                        address.action('select', {
                            resultModel: $scope.checkoutSession,
                            success: function success(result) {
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['smallToolTip.addressUpdated']
                                };
                                $scope.checkoutShippingAddresses.invalidate();
                                $scope.doneFn(address);
                            }
                        });
                    }
                };

                $scope.locale = $locale;

                $scope.onAdd = function () {
                    $state.go('checkout.review.sidebar.addShipping');
                };

                // Construct message object for block non-domestic shipping alert
                var merchantCountry = $scope.checkoutAppData.get('merchant.merchant_country', 'US');

                var countryName = $renderContent('countryList.' + merchantCountry);
                var infoMessage = $renderContent('selectShipping.blockNonDomesticShippingInfo', {
                    shippingCountry: countryName
                });
                $scope.blkNonDomesticShippingMsg = {
                    msgs: [infoMessage],
                    type: 'desc'
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-member-components/src/select-shipping/select-shipping/directive.js
// module id = ./components/xo-member-components/src/select-shipping/select-shipping/directive.js
// module chunks = 1